import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">专题合集</h2>
          <p className="text-sm text-foreground-600 mt-3">按兴趣浏览分类内容，精准找到你最想吃的瓜</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-500 mt-1">{item.count}</span>
              <p className="text-xs text-foreground-600 mt-2 leading-relaxed hidden sm:block">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}